// src/pages/treatments/Dentures.jsx
import { Link } from 'react-router-dom';
import DenturesT6 from '../../Assets/images/DenturesT6.png'
import DP from '../../Assets/images/Dentures.jpg'
const Dentures = () => {
  return (
    <main className="pt-20 md:pt-24 min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-80 md:h-[500px] flex items-center justify-center bg-blue-50">
        <div className="absolute inset-0">
          <img
            src={DenturesT6}
            alt="Dentures"
            className="w-full h-full object-cover brightness-75"
          />
          {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
          {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
            Dentures
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light">
            Custom-fit dentures for natural-looking smiles
          </p>
        </div>
      </section>

      {/* Breadcrumb */}
      {/* <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4 flex flex-wrap items-center text-sm text-gray-600">
          <Link to="/" className="hover:text-blue-600 transition">Home</Link>
          <span className="mx-2">›</span>
          <Link to="/treatments" className="hover:text-blue-600 transition">Treatments</Link>
          <span className="mx-2">›</span>
          <span className="text-blue-600 font-medium">Dentures</span>
        </div>
      </div> */}

      {/* Main Content – Flex Layout */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            {/* Image Section */}
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src={DP}
                alt="Dentures Procedure"
                className="w-full max-w-md rounded-2xl shadow-xl object-cover"
              />
            </div>

            {/* Text Content */}
            <div className="w-full lg:w-1/2 flex flex-col">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Denture Specialists
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Dentures (also known as false teeth) are prosthetic devices constructed to replace missing teeth and are supported by the surrounding soft and hard tissues of the oral cavity. Conventional dentures are removable (removable partial denture or complete denture). However, there are many denture designs, some of which rely on bonding or clasping onto teeth or dental implants (fixed prosthodontics). There are two main categories of dentures, the distinction being whether they are used to replace missing teeth on the mandibular arch or on the maxillary arch.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                3-5 visits are required and several visits to make adjustments may be necessary, the comfort of dentures can be greatly improved by integrating them with implants. Advanced dentures are available at SRIDHAR DENTAL, which use BPS ( BIO- FUNCTIONAL PROSTHETIC SYSTEM )
              </p>

              {/* CTA */}
              <div className="flex justify-start">
                <Link to="/book-appointment" className="bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition">
                  Book Appointment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Dentures;